export default class SubjectModel {
    id: number = 0
    active: number = 0
    description: string = ''
    defaultNote: string | null = null
}


// WEBPACK FOOTER //
// ./ClientApp/src/models/SubjectModel.ts